import { useEffect, useState } from 'react';

import { useIntl } from 'react-intl';

import { useDispatch } from 'react-redux';

import { useSelector } from 'react-redux';

import { Row, Col, Divider } from 'antd';

import gridSelector from 'common/components/grid-view/controllers/selectors';

import { StyledModal } from 'common/components';
import SupplierGrid from './SupplierGrid';
import EditingSupplierItem from './EditingSupplierItem';
import SupplierManagerHintMessage from './SupplierManagerHintMessage';
import SupplierManagerSettingSection from './SupplierManagerSettingSection';

import {
  useSupplierManager,
  useGetSupplierDetail,
} from '../hooks/useSupplierManager';
import { useGetQaSpecDataHeader } from 'pages/qa-spec/query';
import { useGetQaSpecTodoList } from 'pages/qa-spec-workflow/hook';

import { apiHandler } from 'utils/api';
import {
  assignSupplier,
  assignSupplierPIMAcTion,
  editSupplier,
} from 'services/supplier-manager';
import * as memberServices from 'services/members';
import { CustomNotification } from 'common/components';

import Messages from 'i18n/messages/supplier-manager';

import { qaToggleReloadDocumentCertificateTab } from 'pages/qa-spec/controllers/actions';

import * as actionsGridView from 'common/components/grid-view/controllers/actions';

import { useDispatchReloadPage } from 'hooks/useReloadPage';

import { useGetProductFullView, useUserInfo } from 'hooks';

import './SupplierManager.less';
import { useParams } from 'react-router-dom/cjs/react-router-dom';


const SupplierManagerModal = (props) => {
  const intl = useIntl();
  const { userInfo } = useUserInfo();

  const {
    visible,
    setVisible,
    isEdit,
    memberSupplier,
    getSupplierList,
    isPIMAction,
    title,
    productSelected,
    isProduct,
    isProductDetail,
    isQaSpecPath,
    isWorkflowModal = false,
    productId,
  } = props;
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [newParam, setNewParam] = useState(memberSupplier?.supplierId);
  const [supplierContact, setSupplierContact] = useState(null);
  // payload coming from the QA spec settings component
  const [qaSpecPayload, setQaSpecPayload] = useState(null);
  // initial values to feed the QA spec component
  const [initialQaSpecSettings, setInitialQaSpecSettings] = useState(null);
  const dispatch = useDispatch();
  const { id } = useParams();
  const ownerIdValue = id ? id : userInfo?.companyId;

  const {
    state,
    memberId,
    handleAddEntityData,
    handleRemoveEntityData,
    handleUpdateSupplierData,
    handleUpdateSelectedLevel,
    handleUpdateSelectedItems,
    handleUpdateImpersonateLevel,
    handleUpdateSupplierPermission,
    handleResetDataProduct,
  } = useSupplierManager();

  const {
    productData,
    selectedSupplier,
    impersonateLevel,
    supplierPermissions,
    selectedEntityLevel,
  } = state;

  const { supplierDetail } = useGetSupplierDetail(
    memberSupplier?.shareId,
    isEdit
  );

  const { refetchQaSpecDataHeader } = useGetQaSpecDataHeader({
    id: productId,
    isEnabled: false,
  });

  const { handleRefetchProductFullView } = useGetProductFullView({
    productId: productId,
    enabled: false,
  });

  const { refetchQaSpecWorkflowTodoList } = useGetQaSpecTodoList();

  const selectedItemDetailList = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const reloadPage = useDispatchReloadPage();

  const handleSubmit = async () => {
    // // Validate QA Spec settings if visibility is enabled
    // if (qaSpecPayload && qaSpecPayload.isQASpecTemplateVisibility === true) {
    //   if (
    //     qaSpecPayload.isQASpecTemplateDownloadWithData == null ||
    //     qaSpecPayload.isQASpecTemplateUploadOverrideData == null
    //   ) {
    //     CustomNotification.error(
    //       'Please select both download and upload options for QA Spec Template before submitting.'
    //     );
    //     return;
    //   }
    // }

    setLoadingSubmit(true);
    const brokerState = isEdit ? 'edit' : 'assign';

    const params = {
      ...(isEdit && { memberId }),
      permissions: supplierPermissions || [],
      memberShareOutLink: productData.map((productItem) => ({
        id: productItem?.id,
        shareType: 'Product',
      })),
      contactInfoId: supplierContact,
      // include QA spec payload if the user changed any settings
      ...(qaSpecPayload && { qaSpecSettings: qaSpecPayload }),
    };
    const messageSuccessType = isWorkflowModal
      ? Messages.initiateQASpecificationWorkflow
      : Messages.successSupplierMessage[brokerState];

    const successMessage = intl.formatMessage(messageSuccessType);
    const errorMessage = intl.formatMessage(
      Messages.errorSupplierMessage[brokerState]
    );

    const apiService = {
      assign: {
        params: { ...params, supplierId: selectedSupplier?.id },
        service: isPIMAction ? assignSupplierPIMAcTion : assignSupplier,
      },
      edit: {
        params: { ...params, supplierId: memberSupplier?.supplierId },
        service: editSupplier,
      },
    };

    apiHandler({
      params: apiService[brokerState].params,
      service: apiService[brokerState].service,
      successMessage,
      errorMessage,
      successCallback: onSuccessCallback,
      onFinally: onFinally,
    });
  };

  const onSuccessCallback = async () => {
    // after the supplier assign/edit succeeded, send qa spec settings
    if (qaSpecPayload) {
      try {
        const res = await memberServices.updateQaSpecTemplateSettings(qaSpecPayload);
        if (res?.isSuccess) {
          CustomNotification.success('QA spec settings saved');
        } else {
          CustomNotification.error(res?.message);
        }
      } catch (err) {
        CustomNotification.error('Failed to save QA spec settings');
      }
    }

    setVisible(false);
    getSupplierList && getSupplierList();
    if (isProductDetail || isQaSpecPath) {
      refetchQaSpecDataHeader();
      refetchQaSpecWorkflowTodoList();
      dispatch(qaToggleReloadDocumentCertificateTab());
      handleRefetchProductFullView();
    }

    if (selectedItemDetailList?.length > 0) reloadPage();

    dispatch(actionsGridView.deleteItemsSelection());

    // reset qa spec payload after modal closes
    setQaSpecPayload(null);
  };

  const onFinally = () => {
    setLoadingSubmit(false);
  };

  useEffect(() => {
    if (supplierDetail && isEdit) handleUpdateSupplierData(supplierDetail);
    if (isProduct) {
      handleResetAll(productSelected);
    }

    // load QA spec settings when the supplier identifier changes
    const supplierIdValue = selectedSupplier?.id || newParam;

    if (supplierIdValue) {
      const loadSettings = async () => {
        try {
          const res = await memberServices.getQaSpecTemplateSettings({
            memberId: supplierIdValue,
            ownerId: parseInt(ownerIdValue),
            mode: 'supplier',
          });
          setInitialQaSpecSettings(res?.data || null);
        } catch (e) {
          // silent or display error
        }
      };
      loadSettings();
    }
  }, [JSON.stringify(supplierDetail), isProduct, selectedSupplier?.id, newParam]);

  const handleResetAll = () => {
    handleResetDataProduct(productSelected);
  };

  const handleContactSelect = (item) => {
    setSupplierContact(item);
  };

  const handleQaSpecPayload = (payload) => {
    // store payload so it can be included with submit parameters
    setQaSpecPayload(payload ? { ...payload, ownerId: parseInt(ownerIdValue) } : payload);
  };
  const settingSectionProps = {
    productData,
    supplierPermissions,
    impersonateLevel,
    selectedEntityLevel,
    isProduct,
    isProductDetail,
    handleAddEntityData,
    handleRemoveEntityData,
    handleUpdateSelectedLevel,
    handleUpdateImpersonateLevel,
    handleUpdateSupplierPermission,
    handleResetAll,
    newParam,
    handleContactSelect,
    handleQaSpecPayload,
    initialQaSpecSettings,
  };

  // useEffect(() => {
  // }, [newParam, supplierContact, selectedSupplier, productData, isEdit]);

  useEffect(() => { }, [newParam]);

  const disableSubmitButton =
    (!isEdit && !selectedSupplier.id) || productData?.length === 0;
  return (
    <StyledModal
      onCancel={() => {
        setVisible(false);
      }}
      onOk={() => handleSubmit()}
      okText='Submit'
      okButtonProps={{
        disabled: disableSubmitButton,
        loading: loadingSubmit,
      }}
      visible={visible}
      destroyOnClose
      width={isEdit ? 950 : 1220}
      wrapClassName='supplier-management-modal'
      title={
        title ? title : intl.formatMessage(Messages.assignSupplierModalTitle)
      }
      bodyStyle={{ height: '80vh', overflow: 'hidden', padding: 10 }}
      maskClosable={false}
    >
      <Row style={{ height: '100%' }} wrap={false}>
        <Col flex={1}>
          {isEdit ? (
            <Row justify='center'>
              <EditingSupplierItem memberSupplier={memberSupplier} />
            </Row>
          ) : (
            <SupplierGrid
              isPIMAction={isPIMAction}
              selectedSupplier={selectedSupplier}
              handleUpdateSelectedItems={handleUpdateSelectedItems}
              setNewParam={setNewParam}
            />
          )}
        </Col>

        <Divider type='vertical' style={{ height: '100%' }} />

        <Col flex={'500px'}>
          {(newParam && selectedSupplier?.id) || isEdit ? (
            <SupplierManagerSettingSection {...settingSectionProps} selectedSupplier={selectedSupplier} />
          ) : (
            <SupplierManagerHintMessage>
              {intl.formatMessage(Messages.selectSupplierHint)}
            </SupplierManagerHintMessage>
          )}
        </Col>
      </Row>
    </StyledModal>
  );
};

export default SupplierManagerModal;
